import React, { useState, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import UserContext from "./context/UserContext";
import * as Cookies from "js-cookie";
// Material Dashboard 2 PRO React example components
import Sidenav from "scientia/Sidenav";
import "app.css";
// Material Dashboard 2 PRO React themes
import theme from "assets/theme";

// Material Dashboard 2 PRO React Dark Mode themes
import themeDark from "assets/theme-dark";

// Material Dashboard 2 PRO React routes
import routes from "routes";

import auth_routes from "auth_routes";
import user_routes from "user_routes";
import admin_routes from "admin_routes";
// Material Dashboard 2 PRO React contexts
import { useMaterialUIController, setMiniSidenav } from "context";

// Images
import newBrandText from "assets/images/litelogo2text.png";
import newBrandBadge from "assets/images/Litelogo2badge.png";
// cusgom routers
import Bank from "layouts/pages/analyzed/bank";
import Collection from "layouts/pages/collections/collection";
import Search from "layouts/dashboards/search";
import SearchFunctionalityWeb from "layouts/dashboards/SearchFunctionalityWeb";
import SearchFunctionalityMobile from "layouts/dashboards/SearchFunctionalityMobile";
import SearchFunctionalityAppleWatch from "layouts/dashboards/SearchFunctionalityAppleWatch";
import SearchUXWeb from "layouts/dashboards/SearchUXWeb";
import SearchUXMobile from "layouts/dashboards/SearchUXMobile";
import SearchUXAppleWatch from "layouts/dashboards/SearchUXAppleWatch";

import SubID from "layouts/pages/usergroups/SubID";
import NewSub from "layouts/pages/usergroups/NewSub";

import Wizard from "layouts/applications/wizard";
import NoAccess from "layouts/dashboards/noaccess";
import NewWizard from "layouts/applications/new_wizard";
import FirstPage from "layouts/pages/first_page";
import Workspace from "layouts/pages/workspace";
import { useTrackingCode } from "react-hubspot-tracking-code-hook";
import WizardCreate from "layouts/applications/wizard3.0";
export default function App() {
  const { setIdentity } = useTrackingCode();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [userData, setUserData] = useState(null);
  const { pathname } = useLocation();
  const [darkMode, setDarkMode] = useState(false);
  const setUserDataForContext = (data) => {
    if (data) {
      setUserData(data);
    } else {
      setUserData(null);
    }
  };
  const userSettings = {
    userData: userData,
    setUserDataForContext,
  };
  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  const sessionCookie = Cookies.get("session");

  if (sessionCookie !== undefined && userData == null) {
    setUserData(JSON.parse(sessionCookie));
  }
  useEffect(() => {
    if (userData !== null) {
      if (userData.darkMode !== null) {
        setDarkMode(userData.darkMode);
      }
      setIdentity(userData.email);
    }
  }, [userData]);

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <ErrorBoundary>
        <UserContext.Provider value={userSettings}>
          <CssBaseline />
          {layout === "dashboard" && (
            <>
              <Sidenav
                color={sidenavColor}
                brand={
                  (transparentSidenav && !darkMode) || whiteSidenav
                    ? newBrandBadge
                    : newBrandBadge
                }
                brandBig={newBrandText}
                brandName={userData !== null ? userData.firstname : ""}
                routes={
                  userData !== null && userData.roles[0] == "ROLE_USER"
                    ? user_routes
                    : userData !== null && userData.roles[0] == "ROLE_ADMIN"
                    ? admin_routes
                    : routes
                }
                onMouseEnter={handleOnMouseEnter}
                onMouseLeave={handleOnMouseLeave}
              />
            </>
          )}
          <Routes>
            {userData !== null ? (
              <>
                {userData.roles[0].toString() === "ROLE_USER" ? (
                  <>{getRoutes(user_routes)}</>
                ) : (
                  <>
                    {userData.roles[0].toString() === "ROLE_ADMIN" ? (
                      <>{getRoutes(admin_routes)}</>
                    ) : (
                      <>{getRoutes(routes)}</>
                    )}
                  </>
                )}

                {/* <Route path="/wizard/:dashboardId" element=<Wizard />/> */}
                {/* <Route path="/wizard/:dashboardId/:isCopy" element=<Wizard />/> */}
                <Route path="/noaccess" element=<NoAccess /> />

                <Route path="/welcome" element=<FirstPage /> />

                <Route
                  path="/welcome_wizard"
                  element={<WizardCreate welcome />}
                />
                <Route path="/workspace" element=<Workspace /> />
                <Route path="*" element={<Navigate to="/workspace" />} />
              </>
            ) : (
              <>
                {getRoutes(auth_routes)}
                <Route
                  path="*"
                  // element={<Navigate to="/authentication/sign-in/newLogin" />}
                  element={<Navigate to="/authentication/sign-in/basic" />}
                />
              </>
            )}
          </Routes>
        </UserContext.Provider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      let data =
        '<center><br><img src="data:image/png;base64,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"><h6 style="margin: 0;font-size: 1rem;  line-height: 1.625;  font-family: soleilw01-regularregular;color: #344767;font-weight: 700;  opacity: 1;text-transform: none;    vertical-align: unset;  -webkit-text-decoration: none;text-decoration: none;  color: #344767;width: 40%;"><br>An error occured.<Br><br> Click to return to <a href="/workspace" target="_parent">homepage</a></h6></center>';
      return <div dangerouslySetInnerHTML={{ __html: data }} />;
    }

    return this.props.children;
  }
}
